import styles from "./Designer.module.css";

const Stepper = ({ steps = [], currentStep = 1 }) => {
    const safeIndex = Math.max(0, steps.findIndex((step) => Number(step.id) === Number(currentStep)));
    const translateY = `calc(-${safeIndex} * var(--designer-stepper-item-height))`;

    return (
        <div className={styles.stepperWindow}>
            <div className={styles.stepperViewport}>
                <div
                    className={styles.stepperTrack}
                    style={{ transform: `translateY(${translateY})` }}
                >
                    {steps.map((s) => {
                        const isActive = currentStep === s.id;
                        const isDone = currentStep > s.id;
                        return (
                            <div key={s.id} className={`${styles.stepItem} ${isActive ? styles.stepItemActive : ""}`}>
                                <div
                                    className={`${styles.stepBadge} ${
                                        isActive ? styles.stepBadgeActive : isDone ? styles.stepBadgeDone : styles.stepBadgeIdle
                                    }`}
                                >
                                    {isDone ? "✓" : s.id}
                                </div>
                                <span className={`${styles.stepTitle} ${isActive ? styles.stepTitleActive : styles.stepTitleIdle}`}>
                                    {s.title}
                                </span>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default Stepper;
